import React from 'react'

class ErrorMessageCard extends React.Component {
  render() {
    const { title } = this.props
    return (
      <div className="card card-border card-border-red mb-2">
        <div className="media mt-2 d-block d-sm-flex">
          <div className="media-left">
            <div className="material-icons biggest red mt-1 mr-2 mb-2">
              error
            </div>
          </div>
          <div className="content">
            <strong className="big">{title}</strong>
            <div className="smaller">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ErrorMessageCard;
